'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

require('./style.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    OrderSteps: {
        displayName: 'OrderSteps'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Order/OrderSteps/index.js',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var OrderSteps = _wrapComponent('OrderSteps')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        lang: state.lang
    };
}), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(OrderSteps, _Component);

    function OrderSteps(props) {
        (0, _classCallCheck3.default)(this, OrderSteps);
        return (0, _possibleConstructorReturn3.default)(this, (OrderSteps.__proto__ || (0, _getPrototypeOf2.default)(OrderSteps)).call(this, props));
    }

    (0, _createClass3.default)(OrderSteps, [{
        key: 'render',
        value: function render() {
            var lang = this.props.lang;


            var step = this.props.step || 0;
            step = parseInt(step, 10) || 0;

            var classes = {
                1: '',
                2: '',
                3: ''
            };

            if (step) {
                classes[step] = 'active';
            }

            var cartTitle = lang['store.common.cart'];
            var orderDetailsStart = lang['store.order_steps.order_details.start'];
            var orderDetailsEnd = lang['store.order_steps.order_details.end'];
            var orderCheckoutStart = lang['store.order_steps.order_checkout.start'];
            var orderCheckoutEnd = lang['store.order_steps.order_checkout.end'];

            return _react3.default.createElement(
                'div',
                { className: 'block-with-border' },
                _react3.default.createElement(
                    'div',
                    { className: 'order_steps' },
                    _react3.default.createElement(
                        'div',
                        { className: 'steps' },
                        _react3.default.createElement(
                            'div',
                            { className: 'one-step ' + classes[1] },
                            _react3.default.createElement(
                                'div',
                                { className: 'step-wrap' },
                                _react3.default.createElement(
                                    'p',
                                    null,
                                    cartTitle
                                ),
                                _react3.default.createElement(
                                    'div',
                                    { className: 'number-wrap' },
                                    _react3.default.createElement(
                                        'span',
                                        { className: 'step-number' },
                                        ' 1 '
                                    )
                                )
                            )
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'one-step ' + classes[2] },
                            _react3.default.createElement(
                                'div',
                                { className: 'step-wrap' },
                                _react3.default.createElement(
                                    'p',
                                    null,
                                    orderDetailsStart,
                                    ' ',
                                    _react3.default.createElement('br', null),
                                    ' ',
                                    orderDetailsEnd
                                ),
                                _react3.default.createElement(
                                    'div',
                                    { className: 'number-wrap' },
                                    _react3.default.createElement(
                                        'span',
                                        { className: 'step-number' },
                                        ' 2 '
                                    )
                                )
                            )
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'one-step ' + classes[3] },
                            _react3.default.createElement(
                                'div',
                                { className: 'step-wrap' },
                                _react3.default.createElement(
                                    'p',
                                    null,
                                    orderCheckoutStart,
                                    ' ',
                                    _react3.default.createElement('br', null),
                                    ' ',
                                    orderCheckoutEnd
                                ),
                                _react3.default.createElement(
                                    'div',
                                    { className: 'number-wrap' },
                                    _react3.default.createElement(
                                        'span',
                                        { className: 'step-number' },
                                        ' 3 '
                                    )
                                )
                            )
                        )
                    ),
                    _react3.default.createElement('div', { className: 'line-100' })
                )
            );
        }
    }]);
    return OrderSteps;
}(_react2.Component), _class2.propTypes = {
    lang: _react2.PropTypes.object
}, _temp)) || _class));

exports.default = OrderSteps;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Order/OrderSteps/index.js
// module id = 1705
// module chunks = 0